import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Container, CardContent, Button } from '@material-ui/core';
import Page from 'src/components/Page';
import Header from 'src/components/Header';
import SettingsRemoteIcon from '@material-ui/icons/SettingsRemote';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  submitButtonRemote: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));



const handleAVOpen = (event) => {
  const SessionUser = getUser();
  var Adres = process.env.REACT_APP_REMOTE_HELP_URL + "?Param=" + SessionUser.ServiceShopCode + "-"+ SessionUser.UserId;
  event.persist();
  window.open(Adres);
  event.persist();
}
 

function RemoteHelp() {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Ürün Kabul">
      <Container maxWidth="lg">
        <Header />
        <CardContent>
          <Button
            variant="contained"
            color="secondary"
            className={classes.submitButtonRemote}
            onClick={(event) => handleAVOpen(event)}
            endIcon={<SettingsRemoteIcon>Call</SettingsRemoteIcon>}>
            Bağlantı Aç
          </Button>
        </CardContent>
      </Container>
    </Page>
  );
}

export default RemoteHelp;
